module.exports = __webpack_public_path__ + "img/1.c67e5b60.jpg";